import React from 'react';
import { motion } from 'framer-motion';
export function VideoSection() {
  return <section className="relative bg-forest py-20 overflow-hidden" data-id="element-200">
      {/* Subtle top gradient to blend with hero */}
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-forest to-transparent z-10 pointer-events-none" data-id="element-201"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center mb-10" data-id="element-203">
          <span className="text-gold text-sm font-semibold tracking-widest uppercase" data-id="element-204">
            See It in Action
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-cream mt-3" data-id="element-205">
            Design Your Home in Real-Time 3D
          </h2>
          <p className="text-cream/70 mt-3 max-w-xl mx-auto text-lg" data-id="element-206">
            Watch how you can walk through, customize finishes, and explore
            every detail of your future home.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.15
      }} className="relative w-full rounded-lg overflow-hidden shadow-2xl shadow-black/40" style={{
        aspectRatio: '16 / 9'
      }} data-id="element-207">
          {/* Gold accent border */}
          <div className="absolute inset-0 rounded-lg ring-1 ring-gold/20 z-10 pointer-events-none" data-id="element-208"></div>

          <iframe src="https://www.youtube-nocookie.com/embed/QLZC_Lzap6g?autoplay=1&mute=1&loop=1&playlist=QLZC_Lzap6g&controls=1&rel=0&modestbranding=1" title="ResVR Virtual Home Design Experience" className="absolute inset-0 w-full h-full" style={{
          border: 'none'
        }} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-209" />
        </motion.div>
      </div>
    </section>;
}